/**
 * MIRA Popover Component
 * Wraps Shadcn Popover with MIRA design system styles
 */

import React from 'react';
import {
  Popover as ShadcnPopover,
  PopoverTrigger,
  PopoverContent as ShadcnPopoverContent,
} from '@/components/ui/popover';
import { cn } from '@/lib/utils';
import styles from '@/styles/components/popover.module.css';

export const Popover = ({ children, ...props }) => {
  return <ShadcnPopover {...props}>{children}</ShadcnPopover>;
};

export const PopoverContent = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnPopoverContent
        ref={ref}
        className={cn(styles.miraPopoverContent, className)}
        {...props}
      />
    );
  }
);

PopoverContent.displayName = 'MiraPopoverContent';

// Re-export trigger
export { PopoverTrigger };
